import axios from '../../../utils/AxiosUtils';
import {FETCH_UPSELL_SETTINGS, REORDER_UPSELL_PRODUCTS, LOADING, CLEAR_UPSELL_SETTINGS} from "../../types";
import MessageUtils from "../../../utils/MessageUtils";
import i18n from "../../../i18next";

export const createUpsellProduct = (restaurantId, productId, callback) => {
    return (dispatch) => {

        dispatch({type: LOADING, payload: true});

        const url = `/restaurant/${restaurantId}/upsell`;
        const data = {
            productDraft: {
                id: productId
            }
        };

        axios().post(url, data)
            .then(response => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                callback();
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure'));
            })
    }
};

export const loadUpsellSettingsAndProducts = (restaurantId) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});

        const url = `/restaurant/${restaurantId}/upsell`;

        axios().get(url)
            .then(response => {
                dispatch({type: FETCH_UPSELL_SETTINGS, payload: response});
                dispatch({type: LOADING, payload: false});
            })
            .catch(error => {
                    MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:upsellActions.loadUpsellProductsFail'));
                    dispatch({type: LOADING, payload: false});
                }
            )
    }
};

export const removeUpsellProduct = (restaurantId, upsellId, callback) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});

        const url = `/restaurant/${restaurantId}/upsell/${upsellId}`;

        axios().delete(url)
            .then(response => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                    MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:upsellActions.removeUpsellProductsFail'));
                    callback();
                    dispatch({type: LOADING, payload: false});
                }
            )
    }
};

export const reorderUpsellProducts = (restaurantId, oldIndex, newIndex, callback) => {
    return (dispatch, getState) => {

        dispatch({type: REORDER_UPSELL_PRODUCTS, payload: {oldIndex, newIndex}});

        const url = `/restaurant/${restaurantId}/upsell-reorder/`;

        dispatch({type: LOADING, payload: true});
        axios().put(url, getState().upsellSettings.upsellProducts)
            .then(response => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:upsellActions.reorderUpsellProductsFail'));
            })
    }
};

export const setUpsellMessage = (restaurantId, message, callback) => {
    return (dispatch) => {
        const url = `/restaurant/${restaurantId}/upsell/`;

        const data = {
            upsellMessage: message
        };

        dispatch({type: LOADING, payload: true});
        axios().put(url, data)
            .then(response => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                dispatch({type: LOADING, payload: false});
                callback();
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:upsellActions.setMessageFail'));
            })
    }
}

export const clearUpsellSettings = () => {
    return (dispatch) => {
        dispatch({type: CLEAR_UPSELL_SETTINGS, payload: true})
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/upsell/UpsellActions.js